import { AlertCircle } from "@untitledui/icons";
import { LoadingIndicator } from "@/components/application/loading-indicator/loading-indicator";
import {
	DetailField,
	DetailFieldGrid,
	DetailFieldSection,
} from "@/components/base/detail-field/detail-field";
import { TabHeader } from "@/components/base/tab-header";
import { EmptyValue } from "@/components/common";
import { Illustration } from "@/components/shared-assets/illustrations";
import { useAuth } from "@/contexts/AuthProvider";
import { useAppTranslation } from "@/hooks/use-app-translation";

export default function ProfilePreferencesContent() {
	const { t } = useAppTranslation();
	const { user, isLoading } = useAuth();

	const hasError = !user && !isLoading;

	if (isLoading)
		return (
			<div className="flex items-center justify-center text-center h-[calc(100vh-16rem)]">
				<LoadingIndicator type="line-simple" size="xl" supportingText />
			</div>
		);

	if (hasError)
		return (
			<div className="flex flex-col items-center justify-center h-full gap-4">
				<Illustration type="cloud" size="sm">
					<div className="bg-error-500 rounded-full p-3">
						<AlertCircle className="size-6" />
					</div>
				</Illustration>
				<div className="flex flex-col items-center justify-center pt-4">
					<p className="text-gray-900 font-semibold text-md">
						{t("admin.organizations.errors.errorLoadingPage")}
					</p>
					<div className="w-[60%]">
						<p className="text-gray-600 font-normal text-wrap text-center text-sm mt-2">
							{t("admin.organizations.errors.errorLoadingContent")}
						</p>
					</div>
				</div>
			</div>
		);

	return (
		<div className="space-y-6">
			{/* Display Preferences Section */}
			<div>
				<TabHeader title={t("userProfile.preferences.display.title")} />

				<div className="bg-white p-4">
					<div className="space-y-4">
						<DetailFieldGrid>
							<DetailFieldSection>
								<DetailField
									label={t("userProfile.preferences.display.language")}
									value={t("userProfile.preferences.display.languageValue")}
								/>

								<DetailField
									label={t("userProfile.preferences.display.timezone")}
									value={
										Intl.DateTimeFormat().resolvedOptions().timeZone || (
											<EmptyValue />
										)
									}
								/>
							</DetailFieldSection>

							<DetailFieldSection>
								<DetailField
									label={t("userProfile.preferences.display.dateFormat")}
									value={t("userProfile.preferences.display.dateFormatValue")}
								/>

								<DetailField
									label={t("userProfile.preferences.display.timeFormat")}
									value={t("userProfile.preferences.display.timeFormatValue")}
								/>
							</DetailFieldSection>
						</DetailFieldGrid>
					</div>
				</div>
			</div>

			{/* Notification Preferences Section */}
			<div>
				<TabHeader title={t("userProfile.preferences.notifications.title")} />

				<div className="bg-white p-4">
					<div className="space-y-4">
						<DetailFieldGrid>
							<DetailFieldSection>
								<DetailField
									label={t("userProfile.preferences.notifications.email")}
									value={t("userProfile.preferences.notifications.enabled")}
								/>
							</DetailFieldSection>

							<DetailFieldSection>
								<DetailField
									label={t("userProfile.preferences.notifications.push")}
									value={t("userProfile.preferences.notifications.disabled")}
								/>
							</DetailFieldSection>
						</DetailFieldGrid>
					</div>
				</div>
			</div>
		</div>
	);
}
